const { hostname } = window.location;

export const oneIdentifier =
  hostname === 'localhost' ? 'test' : hostname.split('.')[0];
export const isStaging = hostname.includes('.staging.');
